import { useAuthStore } from '@/auth/store';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const DashboardPage = () => {
  const user = useAuthStore((s) => s.currentUser);
  return (
    <div className="p-6">
      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Phase 8 MVP</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <p className="text-base">Привет, {user?.email ?? 'гость'}!</p>
          <p className="text-sm text-muted-foreground">
            Управление аккаунтами, клиентами, складами, trade-links и кампаниями появится в
            следующих планах фазы 8.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
